import { useEffect, useState } from 'react'
import Card from '../../ui/Card'
import {Form, Spinner, Modal} from 'react-bootstrap'
import AddPurposeOfFinanceModal from './addPurposeOfFinanceModal'
import Table from '../../Table'
import IssueFinancePurposeService from '../../../services/IssueFinancePurposeService'
import swal from 'sweetalert'
import { toast } from 'react-toastify'
import { MDBTooltip } from 'mdbreact'
import { AiFillQuestionCircle } from 'react-icons/ai'

const PurposeOfFinancing = (props) => {
    const {finalSaleDetails} = props;
    const [showAddPurposeOfFinanceModal, setShowAddPurposeOfFinanceModal] = useState(false);
    const initialIssuePurposes= JSON.parse(sessionStorage.getItem('purposes')) ? JSON.parse(sessionStorage.getItem('purposes')) : [];
    const [purposes, setPurposes] = useState(initialIssuePurposes)
    const [editIdx, setEditIndex] = useState(-1);
    const [isLoading, setIsLoading] = useState(true);
    const [totalPercentage, setTotalPercentage] = useState(0);
    const [showHelpTextModal, setShowHelpTextModal] = useState(false);


    useEffect(()=> {
        calculateTotal(purposes);
    }, [purposes]);

    useEffect(() => {
        getIssueFinancingPurposesById()
        // eslint-disable-next-line
    },[finalSaleDetails.finalSaleId]);

    const calculateTotal = (purposes) => {
        const total = purposes.reduce((total, item) => total + parseFloat(item.financePurposePct !== "" ? item.financePurposePct : 0), 0);
        setTotalPercentage(total.toFixed(2));
    }

    const getIssueFinancingPurposesById = async () => {
        var obj = {
            msgId: null,
            sysId: null,
            opr: "getIssueFinancePurposesByFinalSaleId",
            hdrStruct: null,
            queryParam: null,
            reqData: {id : finalSaleDetails.finalSaleId },
          };
      
          await IssueFinancePurposeService.getFinancePurposesByIssueId(obj)
            .then((res) => res)
            .then((result) => {    
                setPurposes(result.data.responses[0]);
                props.updateFinalSaleDependencies(result.data.responses[0], 'issueFinancingPurposes');
                setIsLoading(false);
            });
    }
    const updateFinancePurpose = (purposeData)  => {
        let obj = {
            "msgId": null,
            "sysId": null,
            "opr": "putIssueFinancePurpose",
            "hdrStruct": null,
            "queryParam": null,
            "reqData": {
                "id": purposeData.financePurposeId,
                "issueFinancePurpose": purposeData
            }
        };

        IssueFinancePurposeService.updateFinancePurpose(obj)
        .then((res) => res)
        .then((result) => {
        });
    }

    const deleteFinancePurpose = (issueFinancePurposeId)  => {
        let obj = {
            "msgId": null,
            "sysId": null,
            "opr": "deleteIssueFinancePurpose",
            "hdrStruct": null,
            "queryParam": null,
            "reqData": {
              "id" : issueFinancePurposeId,
            }
        };
  
        IssueFinancePurposeService.deleteFinancePurpose(obj)
        .then((res) => res)
        .then((result) => {
            toast.success(
              'Finance Purpose Deleted Successfully'
            )
        });
    }

    const startEditing = i => {
        setEditIndex(i);
    };
    
    const stopEditing = () => {
        setEditIndex(-1);
    };
    const handleOnSave = (i, rowData) => {
        updateFinancePurpose(rowData);
        getIssueFinancingPurposesById();
        setEditIndex(-1);
    }
    const handleRemove = (i, rowData) => {
        const financePurposeId = rowData.financePurposeId;
        deleteFinancePurpose(financePurposeId);
        getIssueFinancingPurposesById();
    }
    const handleChange = (e, name, i) => {
        const { value } = e.target;
        const purposesnew =[...purposes];
        if( name === 'bondTypeDesc') {
            purposesnew[i]['bondType'] = value;
            const displayVal = e.target[e.target.selectedIndex].text;
            purposesnew[i]['bondTypeDesc'] = displayVal;
        } else {
            purposesnew[i][name] = value;
        }

        setPurposes(purposesnew);
        sessionStorage.setItem('purposes',JSON.stringify(purposesnew) )
    }

    const handleModalClose = () => {
        setShowAddPurposeOfFinanceModal(false);
        getIssueFinancingPurposesById();
    }

    const validateForm = (e) => {
        if(purposes.length !== 0) {
            if(totalPercentage !== "100.00") {
                swal("The total value of the Financing Purpose percentages must be equal to 100.00%");
            } else {
                toast.success("Financing Purposes Saved successfully!");
                props.sectionValidated('purposeOfFinancing', true);
                props.openWidget('typeOfSale');
            }
        } else {
            props.sectionValidated('purposeOfFinancing', false);
            alert("Please select at least one Purpose of Financing.");
        }
        
        //navigate("/reports/report-proposed-sale/upload-documents");
    }

    return (
        <Card>
            <Form className="form" id="purposeOfFinancingForm">
                {isLoading && <Spinner animation="border" variant="primary" />}
                {Object.entries(purposes).length !== 0 && <>
                    <Table 
                    handleRemove={handleRemove}
                    startEditing={startEditing}
                    editIdx={editIdx}
                    stopEditing={stopEditing}
                    handleChange={handleChange}
                    handleSave={handleOnSave}
                    data={purposes}
                    header={[
                      {
                        name: "Purpose of Financing",
                        prop: "financePurposeName",
                        fieldType: "input",
                        editable: false
                      },
                      {
                        name: "Percentage",
                        prop: "financePurposePct",
                        fieldType: "input",
                        editable: true
                      }
                    ]}
                    />
                
                <div style={{overflow: 'auto'}}><div style={{float: 'right', display: 'flex'}}><label>Total: </label><input value={totalPercentage} disabled/></div></div>
                </>
                }  
            <span><button type="button" className="custom-button" onClick={() => setShowAddPurposeOfFinanceModal(true)}>Add Purpose</button>
            <MDBTooltip
                    domElement
                    tag="span"
                    placement="right"
                    >
                    <span>{"  "}<AiFillQuestionCircle onClick={()=>setShowHelpTextModal(true)} className="help-icon heading-help-icon"/></span>
                    <span>Click me for more info.</span>
                </MDBTooltip>
                {showHelpTextModal && 
                <Modal show={true} backdrop="static" onHide={()=>setShowHelpTextModal(false)}>
                    <Modal.Body>
                        <div>
                            <span>Prepopulated with data submitted on the RPDI – update if necessary. Indicate the purpose(s) for which the
debt is issued. Refunding and refinancing issues should indicate the purpose of the original financing (i.e., a
refunding issue for an assessment district to provide streets and roads should still be categorized as streets and
roads). Multiple purposes may be added.</span>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="custom-button-secondary btn-secondary" onClick={()=>setShowHelpTextModal(false)}>Close</button>
                    </Modal.Footer>
                </Modal>
                }
            </span>
          
            {showAddPurposeOfFinanceModal && <AddPurposeOfFinanceModal onModalClose={handleModalClose} finalSaleId={finalSaleDetails.finalSaleId}/>}
            <div className="btn-div">
            {/* <button className="custom-button">Back</button> */}
            <button className="fright custom-button" type="button" onMouseDown={(e)=>validateForm(e)}>Save & Next</button>
            </div>
            </Form>
        </Card>
    )
}

export default PurposeOfFinancing
